import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WFWorker } from 'src/app/store/events.era';
import { JoiAccount } from 'globals/store/accounts.data';
import { colorsByPublicEditProfile, publicEditProfileStatusTypes, SocialLink } from '../../store/performers.era';
import { JoiEvent, Label } from 'globals/store/events.data';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { environment } from '../../../environments/environment';
import { ManageWrapperComponent, Tab, TabGroup } from '../manage/manage-wrapper.component';
import { manageSessionReadonlyReselector } from 'src/app/store/reselectors/sessions.reselector';
import { imageUploaderDisplayTypes, JoiFile } from 'globals/store/files.model';
import { Program } from 'globals/store/programs.data';
import { JoiComment } from 'globals/store/tasks.data';
import { BriefInfo, PublicEditProfileInfo, PublicEditProfileStatusTypesType, ShareableItemTypes, shareUrlsByType, StatusType, QuoteStatus } from 'globals/store/share.data';
import { Dictionary } from '@ngrx/entity';
import { Wrapper } from 'src/app/components/wrapper.component';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { ClipLabel } from 'globals/store/entity.data';
import { JoiResource, resourceTabs, ResourceTabs } from 'globals/store/resources.data';
import { resourceDisplayTypes } from '../../store/resources.era';
import { createEmptySection, PublicQuoteInfo, BudgetQuoteSection, Budget } from 'globals/store/reselectors/budget.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../../components/dialog.confirmDelete.component';
import { ManageQuoteDialogComponent } from './manage-quote.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { ManageQuoteData } from '../../store/reselectors/quotes.data';
import { canAccessBudgetReselector } from '../../store/reselectors/budget.reselector';
import { associatedAssetsReselector } from '../../store/reselectors/entity.reselector';
import { UpdateQuestionOutput } from '../../components/entities/custom-questions.component';
import { AppBriefComponent } from '../entities/app-brief.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { EntityTypesComponent } from 'src/app/components/entities/entity-types.component';
import { CommonModule } from '@angular/common';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { ManageSocialLinksComponent } from '../manage/manage-social.component';
import { ResourceContactListComponent } from './resource-contact-list.component';
import { CustomQuestionsAppComponent } from 'src/app/components/entities/custom-questions-app.component';
import { ManageContactComponent } from '../manage/manage-contact.component';
import { AssetsComponent } from '../assets/assets.component';
import { EditAssociatedAssetsManager } from '../assets/edit-associated-assets-manager.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { StatusWrapperComponent } from 'src/app/components/wrappers/status-wrapper.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { ChatBoxComponent } from '../manage/chat-box.component';
import { EntityTasksComponent } from '../manage/entity-tasks.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { InformableComponent } from 'src/app/components/informable/informable.component';
import { AddLinkToBriefComponent } from 'src/app/components/wrappers/add-link-to-brief-wrapper.component';
import { ManageTermsComponent } from '../manage/manage-terms.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { takeUntil } from 'rxjs';
import { jsonCopyObject } from 'globals/helpers/helpers';

type QuoteDotId = 'delete' | 'manage'
interface QuoteDotOption { name: string, id: QuoteDotId }

@Component({
    selector: 'manage-resource',
    templateUrl: './manage-resource.html',
    styleUrls: ['../manage/manage-dialogs.scss', '../assets/assets.scss'],
    styles: [`
  `],
    standalone: true,
    imports: [AppBriefComponent, TipTextComponent, BinaryShareToggle, ManageWrapperComponent, EntityTypesComponent, CommonModule, ImageUploaderComponent, InputEditorComponent, ManageSocialLinksComponent, ResourceContactListComponent, CustomQuestionsAppComponent, ManageContactComponent, AssetsComponent, EditAssociatedAssetsManager, AddManageWrapperComponent, StatusWrapperComponent, IdsToItemsPipe, ChatBoxComponent, EntityTasksComponent, TitleIconComponent, InformableComponent, AddLinkToBriefComponent, ManageTermsComponent, FindByIdPipe],
})
export class ManageResourceDialogComponent extends Wrapper<ManageResourceDialogComponent> implements OnInit {
  resource: JoiResource
  
  labels: Label[] = []
  labelMap: { [id:string]: Label }
  contact: WFWorker
  imageUploaderDisplayTypes = imageUploaderDisplayTypes

  // exhibitorShareable: PublicEditProfileInfo
  resourceShareBaseUrl = environment.joi.shareBase + shareUrlsByType.resource;
  resourceShareable: PublicEditProfileInfo;

  resourceBriefs: Dictionary<BriefInfo> = {}
  resourceDisplayTypes = resourceDisplayTypes
  generatingEditCode = false;
  event: JoiEvent
  budget: Budget
  programs: { [pId:string]: Program } = {}
  tabs = resourceTabs
  addingQuote = false

  tabGroups: TabGroup[] = [{ tabs: [
    { id: resourceTabs.details, name: 'Resource profile' },
    { id: resourceTabs.assets, name: 'Associated Assets' },
    { id: resourceTabs.schedule, name: 'Schedule' },
    { id: resourceTabs.quotes, name: 'Quotes' },
    { id: resourceTabs.quickNotes, name: 'Quick Notes', icon: 'sticky18' },
    { id: resourceTabs.contact, name: 'Workforce contact' },
    { id: resourceTabs.tasks, name: 'Tasks' },
  ]},{
    groupName: 'RESOURCE BRIEF',
    tabs: [ 
      { id: resourceTabs.infoForResource, name: 'Information for resource' },
      { id: resourceTabs.configBrief, name: 'Manage actions' },
      { id: resourceTabs.preview, name: 'Share brief' },
    ]
  }]
  selectedTab: Tab
  clipLabel: ClipLabel
  readOnly: boolean
  deleting = false
  quoteInfos: Dictionary<PublicQuoteInfo> = {}
  quoteColorsByStatus: any = colorsByPublicEditProfile
  quoteStatusOptions: PublicEditProfileStatusTypesType[] = ['Submitted', 'Active', 'Off']
  quoteThreeDotOptions: QuoteDotOption[] = [{ name: 'Delete quote', id: 'delete' }, { name: 'Manage quote', id: 'manage' }]
  budgetAccess = false
  account: Partial<JoiAccount>
  associatedAssetIds: string[] = []

  constructor(public changeDetectorRef: ChangeDetectorRef, public dialogRef: MatDialogRef<ManageResourceDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageResourceData) {
    super()
    this.selectCallback(clipboardEditingPrivilegesReselector, null, canClip => {
      if (canClip && !this.clipLabel) this.clipLabel = '+ ADD TO CLIPBOARD'
    })
    this.subProp(this.store.select('accounts', 'account'), 'account')
    this.subProp(this.store.select('events', 'event'), 'event')
    this.selectProp(canAccessBudgetReselector, null, 'budgetAccess')
    this.selectProp(associatedAssetsReselector, data.resourceId, 'associatedAssetIds')
    this.subProp(this.store.select('budget', 'budget'), 'budget')
    this.subProp(this.store.select('programs', 'entities'), 'programs')
    this.subProp(this.store.select('shareables', 'resource', data.resourceId), 'resourceShareable')
    this.subProp(this.store.select('shareables', 'quote'), 'quoteInfos')
    this.take1(this.store.select('informables', 'resource', this.data.resourceId)).then((informable)=>{
      if (!informable) this.informablesService.checkIfEntityDefaultsAreNeeded('resource', this.eventService.eventId, this.data.resourceId)
    })
    this.subProp(this.store.select('shareables','resourceBrief'), 'resourceBriefs')

    this.data.tab = this.data.tab
    if (this.data.tab) this.selectedTab = this.tabGroups[0].tabs.find(t => t.id === this.data.tab)
  }
  

  ngOnInit() {
    this.subCallback(this.store.select('events', 'labelMaps', 'resource_labels'), labels => {
      this.labels = Object.values(labels)
      this.labelMap = labels
    })
    this.subProp(this.store.select('resources', 'entities', this.data.resourceId), 'resource')
    this.store.select('resources', 'entities', this.data.resourceId).pipe(takeUntil(this.$destroy)).subscribe(resource => {
      this.resource = jsonCopyObject<JoiResource>(resource)
    })
    this.subProp(this.store.select(manageSessionReadonlyReselector), 'readOnly')
  }

  async addQuoteRequest() {
    // this.resourceService.addQuoteToResource(this.resource)
    if (this.addingQuote) return
    
    this.addingQuote = true
    const quoteId = await this.shareService.generateShareCode()
    const quoteSection: BudgetQuoteSection = { ...createEmptySection(this.account, true, quoteId), resourceId: this.resource.id, resourceName: this.resource.name || null }
    
    const quoteInfo: PublicQuoteInfo = { eventId: this.event.eventId, resourceId: this.resource.id, quoteId, status: 'Off', quoteStatus: 'Pending', accountId: this.account.id }
    await this.shareService.upsertPublicQuoteInfo(quoteInfo)

    this.resource.quoteIds.push(quoteId)
    await this.saveResource()

    this.budget.quotes[quoteId] = quoteSection
    await this.budgetService.updateBudget(this.event.eventId, this.budget)

    this.editQuote(quoteSection, true)
    this.addingQuote = false
  }

  public labelUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsToggled) {
      this.resource.labels = labels
      this.resourceService.updateResource(this.resource)
    }
    if (labelsChanged ) {
      this.eventService.updateEvent(this.eventService.eventId, { resource_labels: labelTemplate })
    }
  }

  async clip() {
    switch(this.clipLabel) {
      case '+ ADD TO CLIPBOARD':
        this.clipLabel = 'SAVING...'
        await this.resourceService.templateResources([this.resource])
        this.clipLabel = 'ADDED'
        break
      default:
        break // nothing to do
    }
  }

  shareUrl(shareOn: boolean) {
    const brief = this.resourceBriefs[this.resource.id]
    if (!brief) {
      this.shareBriefsService.addNewBrief('resource', this.resource.id)
      return
    }
    this.shareBriefsService.changeBriefShareStatus(brief, shareOn ? 'On' : 'Off')
  }

  saveFiles(files: JoiFile[]) {
    this.resource = { ...this.resource, files }
    this.saveResource()
  }

  changeTab(tab) {
    this.selectedTab = tab
  }

  saveStars(stars: number) {
    this.resource = { ...this.resource, stars }
    this.saveResource()
  }

  saveSocialLinks(links: SocialLink[]) {
    this.resource = { ...this.resource, social: links }
    this.saveResource()
  }

  changeLogo(result) {
    this.resource = { ...this.resource, logoUrl: result ? result.thumbUrl : null, fullLogoUrl: result ? result.photoUrl : null }
    this.saveResource()
  }

  exit() {
    this.dialogRef.close()
  }

  toggleResourceConfirmed() {
    this.resource = { ...this.resource, confirmed: !this.resource.confirmed }
    this.saveResource()
  }

/*   toggleHideInPublish() {
    this.resource = { ...this.resource, hideInPublish: !this.resource.hideInPublish };
    this.saveResource();
  } */

  toggleDetailsConfirmed() {
    this.resource = { ...this.resource, confirmed: !this.resource.confirmed }
    this.saveResource()
  }

  updateResourceName(name: string) {
    if (!this.resource.quoteIds.length) {
      this.resource = { ...this.resource, name }
      this.saveResource()
    } else {
      this.resourceService.updateResourceName(this.event.eventId, this.resource.id, name)
    }

  }

  toggleResourceProfile() {
    if (!this.resourceShareable) {
      this.createResourceProfileShareable()
    } else if (this.resourceShareable.status !== publicEditProfileStatusTypes.Off) {
      this.changeResourceProfileStatus(publicEditProfileStatusTypes.Off)
    } else {
      this.changeResourceProfileStatus(publicEditProfileStatusTypes.Active)
    }
  }

  async createResourceProfileShareable () {
    this.generatingEditCode = true;
    await this.shareService.createEditProfileCode(this.resource.id, this.event.eventId, 'resource')
    this.generatingEditCode = false
  }

  changeResourceProfileStatus(status){
    const profile: PublicEditProfileInfo = { code: this.resourceShareable.code, status, resourceId: this.resource.id }
    // console.log({ profile })
    this.shareService.updateProfileInfo(profile)
  }

  updateShowEditProfileLinkInBrief() {
    this.resource = { ...this.resource, showEditProfileLinkInBrief: !this.resource.showEditProfileLinkInBrief }
    this.saveResource()
    if (!this.resourceShareable) this.createResourceProfileShareable()
    else if (this.resource.showEditProfileLinkInBrief && this.resourceShareable?.status !== 'Active') this.changeResourceProfileStatus('Active')
  }


  updateShowEditQuoteInBrief(quoteInfo: PublicQuoteInfo){
    if (quoteInfo.status === 'Off') {
      quoteInfo.editLinkInBrief = true
      quoteInfo.status = 'Active'
    } else quoteInfo.editLinkInBrief = !quoteInfo.editLinkInBrief

    console.log({ quoteInfo })
    this.shareService.upsertPublicQuoteInfo(quoteInfo)
  }

  setQuoteInfoStatus(quoteInfo, status) {
    console.log({ quoteInfo, status })
    quoteInfo.status = status
    this.shareService.upsertPublicQuoteInfo(quoteInfo)
  }
  
  async changeWorkforceContact(personEmail: string) {
    const workforceContactEmail = personEmail === this.resource.workforceContactEmail ? null : personEmail
    this.resource = { ...this.resource, workforceContactEmail }
    this.saveResource()
  }

  updateCustomQuestion(data: UpdateQuestionOutput) {
    const { id, answer } = data
    this.resource.customQuestions[id] = answer
    this.saveResource()
  }

  async saveResource() {
    await this.resourceService.updateResource(this.resource)
  }

  async deleteResource() {
    this.deleting = true
    this.readOnly = true
    await this.resourceService.deleteResource(this.resource)
    this.dialogRef.close()
  }

  async duplicateResource() {
    this.dialogRef.close()
    this.resourceService.duplicateResource(this.resource)
  }

  saveQuickNotes(quickNotes: JoiComment[]) {
    // console.log({ quickNotes })
    this.resource.quickNotes = quickNotes
    this.saveResource()
  }

  dotMenuSelection(quoteInfo: PublicQuoteInfo, { event, option }: { event: any, option: QuoteDotId }) {
    const quote = this.budget ? this.budget.quotes[quoteInfo.quoteId] : null
    console.log({ quoteInfo, option })
    if (!quote) {
      console.log("No quote!  Should not be able to do a dot menu selection for quotes without budget / budget access")
      return
    }
    switch (option) {
      case 'delete':
        this.deleteQuoteWithConfirm(quote, event)
        break
      case 'manage':
        this.editQuote(quote)
        break;
      default:
        console.log(`Missing selection [${option}] from three dot menu`)
        break;
    }
  }

  changeQuoteInfoStatus(quoteInfo: PublicQuoteInfo, status: StatusType) {
    quoteInfo.status = status as PublicEditProfileStatusTypesType
    this.shareService.upsertPublicQuoteInfo(quoteInfo)
  }

  changeQuoteStatus(quoteInfo: PublicQuoteInfo, status: QuoteStatus) {
    quoteInfo.quoteStatus = status
    this.shareService.upsertPublicQuoteInfo(quoteInfo)
  }

  async editQuote(quote: BudgetQuoteSection, focusSectionName: boolean = false) {
    const data: ManageQuoteData = { quoteId: quote.id, resourceId: this.data.resourceId, focusSectionName }
    console.log("Should be editing quote", { quote, data })
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageQuoteDialogComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
    this.changeDetectorRef.detectChanges()

  }


  async deleteQuoteWithConfirm(quote: BudgetQuoteSection, event) {
    const rect = event.target.getBoundingClientRect();
    const data: ConfirmDeleteData = {
      title: 'Are you sure you want to delete this quote',// 'Delete ' + (quote.name || 'unnamed quote section') + ' from this resource / event',
      deleteButtonText: 'DELETE',
      rect,
      bottomOffset: -45,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    console.log({ quote, resource: this.resource })
    const budgetQuoteIds = new Set(Object.keys(this.budget.quotes))
    this.resource.quoteIds = this.resource.quoteIds.filter(id => id !== quote.id && budgetQuoteIds.has(id))
    await this.saveResource()

    delete this.budget.quotes[quote.id]
    await this.budgetService.updateBudget(this.event.eventId, this.budget)
    await this.shareService.deleteQuoteInfo(quote.id)
  }



}

export interface ManageResourceData {
  resourceId: string
  tab?: keyof ResourceTabs
}
